module.exports = __webpack_public_path__ + "img/banner3.58a94a1f.png";